<template>
  <transition name="modal">
    <div
      v-if="value"
      class="modal-overlay"
      style="position: absolute !important"
    >
      <div
        class="modal-content"
        :style="`backgroundImage: url(${backgourndImage})`"
      >
        <div
          class="brand-header position-relative"
          :class="
            game.name === 'CoolWashRun'
              ? 'brand-header_cool'
              : 'brand-header_enzym'
          "
        >
          <v-btn
            x-small
            style="position: absolute; left: 10px; top: 16px"
            class="btn-delete ma-0 position-absolute"
            icon
            @click="close"
            title="بستن"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <img :src="srcImage" alt="پودر لباسشویی سپید۵" class="product-logo" />
          <h5>{{ game.title }}</h5>
          <small class="subtitle">{{ game.subtitle }}</small>
        </div>
        <div class="game-wrapper">
          <div class="game-container-wrapper">
            <component :is="game.component" @close="close" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EnzymeSquad from "./EnzymeSquad.vue";
import CoolWashRun from "./CoolWashRun.vue";
import SortItOut from "./SortItOut.vue";

export default {
  name: "GameModal",
  components: { EnzymeSquad, CoolWashRun, SortItOut },
  props: {
    value: Boolean,
    game: Object,
  },
  computed: {
    srcImage() {
      return this.game.name == "EnzymeSquad"
        ? require("@/assets/images/game/280x280.webp")
        : this.game.name == "CoolWashRun"
        ? require("@/assets/images/game/sepid5.webp")
        : require("@/assets/images/game/logo (2).webp");
    },
    backgourndImage() {
      return this.game.name == "EnzymeSquad"
        ? require("@/assets/images/game/background1.webp")
        : this.game.name == "CoolWashRun"
        ? require("@/assets/images/game/background12.webp")
        : require("@/assets/images/game/background11.webp");
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 201 !important;
}

.modal-content {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 0px;
  /* width: 90%; */
  width: 100%;
  max-width: 440px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
  perspective: 1500px;
  transform-style: preserve-3d;
  justify-content: center;
  justify-items: center;
}

.game-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.game-container-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.brand-header {
  text-align: center;
  padding: 10px;
  color: white;
  text-shadow: #000a16b2;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  /* background: transparent; */
}
.brand-header_cool {
  background: linear-gradient(135deg, #01589b79, #00ad5c77);
}
.brand-header_enzym {
  background: linear-gradient(135deg, #cfb26262, #9a284588);
}

.product-image {
  width: 40px;
  height: auto;
  border-radius: 7px;
}

/* رسانه کوئری برای ریسپانسیو بودن در دستگاه‌های کوچک */
@media (max-height: 600px) {
  .modal-content {
    height: 95vh;
    padding: 10px;
  }
  .enzyme-game h1 {
    font-size: 1.4em;
  }
  .stain {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 400px) {
  .enzyme-controls {
    grid-template-columns: 1fr;
  }
}
.product-logo {
  position: absolute;
  width: 35px;
  right: 10px;
  top: 10px;
  height: auto;
  margin-left: 3px;
  margin-bottom: 5px;
  border-radius: 5px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

h1 {
  font-size: 1.6em;
  margin: 0;
}

.subtitle {
  margin: 5px 0;
}
.btn-delete {
  left: 10px;
  top: 16px;
  padding: 15px;
  display: flex !important;
  border-radius: 50% !important;
  margin: 10px;
  text-align: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  transition: 0.7s !important;
  font-weight: bold !important;
  background-size: 200% auto;
  display: block;
  background-image: linear-gradient(
    to right,
    rgba(150, 0, 0, 1) 0%,
    rgba(255, 0, 0, 1) 51%,
    rgba(150, 0, 0, 1) 100%
  );
  background-position: right center;
  color: #fff !important;
}

.btn-delete:hover {
  background-image: linear-gradient(
    to right,
    rgba(150, 0, 0, 1) 0%,
    rgba(255, 0, 0, 1) 51%,
    rgba(150, 0, 0, 1) 100%
  );
  border: 1px solid rgba(150, 0, 0, 1) !important;
  background-position: right center;
  color: #fff !important;
  text-decoration: none !important;
  border: none !important;
  transition: 0.7s !important;
  font-weight: bold !important;
  box-shadow: 0 0 20px #eee;
}
</style>
